import React, {Component} from "react";
import Link from "gatsby-link";
import {auth, db, firebase} from "../firebase";
import {storage} from "../firebase/firebase";
import styled from "styled-components";
import colors from "../styles/colors";
import plus from "../images/plus.svg";
import deleteIcon from '../images/delete.svg';
import insert from '../images/insert.png'
import removeList from '../images/removeList.svg'
import {NotificationContainer, NotificationManager} from "react-notifications";
import 'react-notifications/lib/notifications.css';
import _ from 'underscore';
import {Tips} from '../Components/Tips';

import {
    AppContainer,
    Header,
    Heading,
    Body,
    MainAction,
    SortableListBody,
    CreateAppContainer,
} from "../Components/AppChrome";
import {SearchBox, SearchHits, SearchHit} from "../Components/Search";
import SortableList from "../Components/SortableList";
import {
    GreenLargeButton,
    DisabledButton,
    LogoutButton,
    SortingButton,
    BlueButton,
    DisableCommentButton
} from "../Components/Button";
import previous from "../images/back.svg";
import googleSignIn from "../images/btn_google_signin_light_normal_web@2x.png";
import optimumLogo from "../images/optimum.png";
import en from "../locales/en/translation.json";
import spn from "../locales/sp/translation.json";
import swe from "../locales/sw/translation.json";

//TODO:
// * Add preferredLanguage and email to user object
// * Add posturalvardag to PDF program
// * Client-side validation of numbers, email address, string lengths
// * Hover and click effects
// * Move up/down animation (transform: translateY(100%/-100%))
// * Verify email adress of new user? Don't allow invalid characters!
// * Localized strings, timestamps
// * Error message when user already exists
// * Possibility to "claim" customers without a clinic
// * Add photoUrl to user if missing
// * Add program sent status to program list
// * Autosvar för anmälan till föreläsning
// * Scroll up automatically on program list: show + new

const NoFoundText = styled.div`
width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 1rem;
  text-align:center;
  font-weight: 500;
  color: ${colors.dark};
  line-height: 1.3;
  margin-top:230px
`;

const MailSpan = styled.span`
 font-size: 1rem;
 font-weight: 500;
 color:${colors.first}
`;


const Info = styled.div`
  padding: 1rem;
`;
const EmailInfo = styled.div`
  padding: 1rem;
  margin-top:-20px
`;

const EllipsisText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const InputContainer = styled.div`
  padding: 0rem 1rem 1rem;
  background-color: ${colors.first};
`;

const Input = styled.input`
  width: 100%;
  height: 1rem;
  background-color: ${colors.bright};
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 2px;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
&::placeholder {
    color: ${colors.light};
  }
`;
const InputExerciseCreate = styled.input`
  width: 100%;
  margin-top:7px
  height: 0.5rem;
  background-color: ${colors.bright};
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 2px;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
 &::placeholder {
    color: ${colors.light};
  }
`
const InstructionHeaderInput = styled.input`
  width: 100%;
  height: 0.3rem;
  background-color: ${colors.bright};
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 15px;
  border-radius: 2px;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
 &::placeholder {
    color: ${colors.light};
  }
`

const InstructionBodyInput = styled.input`
  display:flex
  width: 100%;
  height: 0.3rem;
   padding: 0.5rem 1rem 0.5rem 1rem;
  margin-top:10px;
  background-color: ${colors.bright};
  font-size: 15px;
  border-radius: 2px;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
 &::placeholder {
    color: ${colors.light};
  }
`

const InputEmailBox = styled.input`
  width: 100%;
  height: 15px;
  background-color: ${colors.bright};
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 1rem;
  margin-top:10px;
  border-radius: 2px;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};

  &::placeholder {
    color: ${colors.light};
  }
`;
const PurposeArea = styled.textarea`
  width: 100%;
  height: 5rem;
  padding: 0.2rem 1rem 0.2rem 1rem;
  margin-top:7px
  background-color: white;
  font-size: 1rem;
  border-radius: 2px;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;

  &::placeholder {
    color: ${colors.light};
  }
`;

const Label = styled.label`
`

const TextArea = styled.textarea`
  width: 100%;
  height: 10rem;
  background-color: white;
  padding: 1rem;
  font-size: 1rem;
  border-radius: 2px;
  border: 2px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;

  &::placeholder {
    color: ${colors.light};
  }
`;

const Flex = styled.div`
  display: flex;
`;
const ItemAction = styled.div`
  width:100%
  margin-top: -13px;
  background-color: ${colors.first};
  display: flex;
  justify-content: flex-end

`;
const LogoutItemAction = styled.div`
  width:100%
  margin-top: -50px;
  margin-bottom:15px;
  background-color: ${colors.first};
  display: flex;
  justify-content: flex-end
`;

const SortingItemAction = styled.div`
  width:100%
  background-color: ${colors.first};
  display: flex;
  justify-content: flex-center;
  border:1px solid 
`

const EmailText = styled.div`
margin-top:15px 
font-size: 20px;
`;
const AboveEmailText = styled.div`
margin-top:-5px 
font-size: 20px;
`;
const TitleDivision = styled.div`
margin-top: 3px;
font-size: 15px;
font-weight: 500;   
`
const InputText = props => {
    return (
        <Flex>
            <Input
                type={"text"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};
const CreateExerciseInputText = props => {
    return (
        <Flex>
            <InputExerciseCreate
                type={"text"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};
const InstructionBody = props => {
    return (
        <Flex>
            <InstructionBodyInput
                type={"text"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};
const InstructionHeader = props => {
    return (
        <Flex>
            <InstructionHeaderInput
                name={props.name}
                type={"text"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};
const SetsRepsInput = props => {
    return (
        <Flex>
            <CreateSetsReps
                type={"text"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};
const RepUnitsInput = props => {
    return (
        <Flex>
            <RepeatUnits
                type={"text"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};
const ImageInput = props => {
    return (
        <Flex>
            <ImageInputStyle
                multiple
                type={"file"}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};


const InputEmail = props => {
    return (
        <Flex>
            <InputEmailBox
                type={"email"}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};

const InputTextArea = props => {
    return (
        <Flex>
            <TextArea
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};
const LabelArea = props => {
    return (
        <Flex>
            <Label/>
        </Flex>
    );
};
const PurposeTextArea = props => {
    return (
        <Flex>
            <PurposeArea
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </Flex>
    );
};


const IconButton = props => {
    return <ItemIcon src={props.icon} alt="" onClick={props.onClick}/>;
};

const PlusIconButton = props => {
    return <PlusIcon src={props.icon} alt="" onClick={props.onClick}/>;
};
const DeleteIconButton = props => {
    return <DeleteIcon src={props.icon} alt="" onClick={props.onClick}/>;
};
const RemoveListIconButton = props => {
    return <RemoveList src={props.icon} alt="" onClick={props.onClick}/>;
};
const InsertIconButton = props => {
    return <InsertIcon src={props.icon} alt="" onClick={props.onClick}/>;
};


const ItemIcon = styled.img`
  height: 1.1rem;
`;
const InsertIcon = styled.img`;
   margin-left : 10px
  height: 1.5rem;
  cursor:pointer
 
`;
const InsertDiv = styled.div`
width:100%
`


const PlusIcon = styled.img`
margin-top:10px;
  height: 1.5rem;
  cursor:pointer
`;
const DeleteIcon = styled.img`
  margin-left : 10px
  height: 1.5rem;
  cursor:pointer
`;
const RemoveList = styled.img`
  margin-left : 10px
  height: 1.2rem;
  cursor:pointer
`;
const TrackSwitch = props => {
    return (
        <ItemTrackSwitch
            readOnly={props.readOnly}
            selected={props.selected}
            onClick={props.onClick}
        >
            {props.children}
        </ItemTrackSwitch>
    );
};

const OptimumLogo = styled.div`
  background: url(${optimumLogo}) no-repeat;
  background-position: center;
  background-size: 25rem;
  width: 100%;
  height: 60%;
`;
const ButtonImage = styled.img`
  display: inline-block;
  width: 191px;
  cursor:pointer;
`;

const ItemTrackSwitch = styled.div`
 cursor:pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: initial;
  text-align: center;
  height: 2rem;
  width: 2rem;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom:8px
  text-transform: uppercase;
  border-radius: 2px;
  border: 2px solid transparent;
  background-clip: padding-box;
  color: ${colors.bright};
  background-color: ${props =>
    props.selected
        ? props.readOnly
        ? colors.middle
        : colors.lightYellow
        : colors.light};
  padding: 1px;
  outline: none;
`;

//Creeate Exercise Portion

const CreateExerciseText = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-transform: capitalize;
  font-size: 1rem;
  font-weight: 500;
  color: ${colors.dark};
  line-height: 1.3;
 `
const Note = styled.div`
width:100%;
text-align:center;
font-size:15px;
margin-bottom:10px;
color:red;
`
const ImageNote = styled.div`
width:100%;
text-align:center;
font-size:15px;
margin-bottom:30px;
color:black;
`
const CommonPadding = styled.div`
 padding: 0.5rem 1.75rem;
 `
const SetsAndReps = styled.div`
 display: flex;
 flex-direction: row;
 margin-top:15px;
 `

const Purpose = styled.div`
 margin-top:15px;
`
const CreateSetsReps = styled.input`
  width: 70%;
  margin-top:7px
  height: 0.5rem;
  background-color: ${colors.bright};
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 2px;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
 &::placeholder {
    color: ${colors.light};
  }
`
const RepeatUnits = styled.input`
  width: 90%;
  margin-top:7px
  height: 0.5rem;
  background-color: ${colors.bright};
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 2px;
  border: 1px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
 &::placeholder {
    color: ${colors.light};
  }
`

const ExerciseImage = styled.div`
 display: flex;
 flex-direction: row;
 margin-top:10px;
 width:100%;
 `
const SaveButtonDivision = styled.div`
margin-top:10px;
text-align:center;
`
const ImageDivision = styled.div`
 width:100%;
 text-align:center
 `
const InsertButtonDiv = styled.div`
text-align: right;
    width: 111%;
    margin-top: -26px;`
const InsertButtonDivMain = styled.div`
text-align: right;
    width: 109%;
    margin-top: -26px;`
const GoalAndDirectives = styled.div`
 margin-top:10px;
 width:100%;
 border-bottom: 1px solid #cccccc;
 `
const ImageInputStyle = styled.input`
 margin-top:7px
  background-color: ${colors.bright};
  border-radius: 2px;
  font-size:15px;
  outline: none;
  color: ${colors.dark};
 &::placeholder {
    color: ${colors.light};
  }
`
const ParticularExercise = styled.img`
 height: 130px;
    width: 200px;
    margin-top: 15px;
    margin-bottom: 20px;
`;
const Container = styled.div`
  width: 100%;

`;
const ImageContainer = styled.div`
text-align:center
width: 100%;`
const CrossContainer = styled.div`
   margin-left: -4px;
    width: 10%;
    margin-right: 9px;
    margin-top: 35px;
 `
const List = styled.ul`
 padding-inline-start: 20px !important;
  margin:auto ;
`;
const ListItem = styled.li`
  margin-top:10px;
      font-size: 15px;
    color: #150202ad;
    text-align:justify;
   
  
`;
const RemoveButtonListItem = styled.li`
  margin-top:10px;
      font-size: 15px;
    color: #150202ad;
    text-align:justify;
    list-style-type: none;
  
`;


class NewPage extends Component {
    constructor(props) {
        super(props);
        this.searchBox = null;

        this.state = {
            authenticating: false,
            authUser: null,
            programName: "",
            currentProgram: 0,
            currentExerciseNumber: null,
            currentMediumExerciseNumber: null,
            nextExerciseId: 1,
            exercises: [],
            allInstructions: [],
            instructions: [],
            searchText: "",
            user: null,
            userId: "",
            anotherEmailAddress: "",
            showingInstruction: null,
            showingInstructionStep: 0,
            addingExercise: false,
            addingMessage: false,
            message: "Lycka till med träningen!\n\n",
            comment: "",
            modalIsOpen: false,
            currentIndex: null,
            multiTrackArray: [],
            shortTrackArray: [],
            multiTrackFlag: false,
            shortTrackFlag: false,
            longTrackFlag: false,
            currentVersionIndex: 2,
            exerciseVersion: [{version: 'S'}, {version: 'M'}, {version: 'L'}],
            buttonChange: false,
            createExercise: false,
            exerciseName: "",
            sets: "",
            reps: "",
            purpose: "",
            repeatUnits: "",
            abbreviation: "",
            selectedImage: null,
            level: '',
            videoId: '',
            demoLevel: "200",
            url: '',
            mainArray: [{
                firstName: '',
                lastName: '',
                directives: [],
                alternatives: [],
                image: '',
                title: '',
                goal: '',
                alterText: '',
                progress: 0,
                base64: ''
            }],
            listItem: '',
            currentAddIndex: 0,
            practitionerData: {},
            // progress:0,
            edit: false,
            doubleClickEdit: false,
            listIndex: 0,
            editObject: {},
            masterUserId: 'info@optimum-metoden.se',
            instructionHit: true,
            addTipsPage: false,
            titleText: "",
            bodyText: "",
            Tips: [],
            showBase64: false,
            mainLanguage: '',
            loader: false,
            demoArray: [],
            modifiedBy:''
        };

        this.onChangeGrouped = this.onChangeGrouped.bind(this);
        this.onChangeShortTrack = this.onChangeShortTrack.bind(this);
        this.onChangeMultiTrack = this.onChangeMultiTrack.bind(this);
        this.onRemoveExercise = this.onRemoveExercise.bind(this);
        this.setSearchBoxRef = this.setSearchBoxRef.bind(this);
        this.onCommentChange = this.onCommentChange.bind(this);
        this.onModelClose = this.onModelClose.bind(this);
        this.onSaveComment = this.onSaveComment.bind(this);
        this.addMultipleFields = this.addMultipleFields.bind(this);
        this.addExercise = this.addExercise.bind(this);
    }

    setSearchBoxRef(searchBoxRef) {
        this.searchBox = searchBoxRef;
    }

    onFocusSearchBox() {
        if (this.searchBox) {
            this.searchBox.focus();
        }
    }

    onSignIn = event => {
        auth.doGoogleSignInWithRedirect();
    };

    onAddMessage = event => {
        this.setState({addingMessage: true}, () => {
            window.scrollTo(0, 0);
        });
    };

    onCancelAddMessage = event => {
        this.setState({addingMessage: false});
    };

    onPublishProgram = event => {
        db.publishProgram(
            this.state.user.id,
            this.state.currentProgram,
            this.state.programName,
            this.state.message,
            this.state.anotherEmailAddress,
            this.state.mainLanguage
        );
        setTimeout(() => {
            this.setState({
                addingMessage: false
            });
            this.props.history.push({
                pathname: "/",
                search: "?user=" + this.state.user.id
            });
        }, 3000)

    };

    onSelect = event => {
        const selectedIndex = Number(event.currentTarget.id);
        if (this.state.currentExerciseNumber === selectedIndex) {
            this.setState({currentExerciseNumber: null, currentMediumExerciseNumber: null});
        } else {
            this.setState({
                currentExerciseNumber: Number(event.currentTarget.id),
            });
        }
    };
    onMediumVersionSelect = event => {
        const selectedIndex = Number(event.currentTarget.id);
        if (this.state.currentMediumExerciseNumber === selectedIndex) {
            this.setState({currentMediumExerciseNumber: null,});
        } else {
            this.setState({
                currentMediumExerciseNumber: Number(event.currentTarget.id),
            });
        }
    }
    onKeypress = event => {
        switch (event.keyCode) {
            case 13: //enter
                event.currentTarget.id = this.state.instructions.length > 0 ? this.state.instructions[0].id : null;
                this.addExercise(event);
                break;
            case 27: //escape
                this.onCancelAddExercise(event);
                break;
            case 32: //space
                this.setState({currentExerciseNumber: null});
                break;
            case 37: //left
            case 38: //up
                if (this.state.exercises && this.state.exercises.length > 0) {
                    event.currentTarget.parentElement.parentElement.id = this.state.currentExerciseNumber;
                    this.onMoveUp(event);
                }
                break;
            case 39: //right
            case 40: //down
                if (this.state.exercises && this.state.exercises.length > 0) {
                    event.currentTarget.parentElement.parentElement.id = this.state.currentExerciseNumber;
                    this.onMoveDown(event);
                }
                break;
        }
    };

    onNext = event => {
        const currentExerciseNumber =
            this.state.currentExerciseNumber === null
                ? -1
                : this.state.currentExerciseNumber;
        if (currentExerciseNumber < this.state.exercises.length - 1) {
            this.setState({currentExerciseNumber: currentExerciseNumber + 1});
        }
    };

    onPrevious = event => {
        const currentExerciseNumber =
            this.state.currentExerciseNumber === null
                ? this.state.exercises.length
                : this.state.currentExerciseNumber;
        if (currentExerciseNumber > 0) {
            this.setState({currentExerciseNumber: currentExerciseNumber - 1});
        }
    };

    onChangeSearchText = event => {
        const searchText = event.target.value;
        let {allInstructions} = this.state;
        let searchTerm = new RegExp(searchText, "gi");
        let instructions = [];
        if (searchText.length === 1 && this.state.buttonChange === false) {
            instructions = _.sortBy(allInstructions)
            // instructions = this.state.allInsrssstructions
            //     .slice(0)
            //     .sort((a, b) => Number(a.ordinal) - Number(b.ordinal));

        } else {
            if (searchText.length === 1 && this.state.buttonChange === true) {
                instructions = _.sortBy(allInstructions, 'flowNumber');
            }
            // instructions = this.state.allInstructions.filter(
            //     instruction => instruction.id.toUpperCase() === searchText.toUpperCase()
            // );
            else {
                instructions = _.filter(this.state.allInstructions, (instruction) => {
                    return (instruction.id.toUpperCase() === searchText.toUpperCase() && (instruction.userId === this.state.masterUserId || instruction.userId === this.state.userId || instruction.userId===this.state.modifiedBy))
                })
            }
        }


        if (instructions.length === 0) {
            instructions = _.filter(this.state.allInstructions, (instruction) => {
                return instruction.name.match(searchTerm)
            })
            // instructions = this.state.allInstructions.filter(instruction =>
            //     instruction.name.match(searchTerm),
            // );
        }

        if (instructions.length === 0) {
            instructions = _.filter(this.state.allInstructions, (instruction) => {
                return instruction.id.match(searchTerm)
            })
            // instructions = this.state.allInstructions.filter(instruction =>
            //     instruction.id.match(searchTerm)
            // );
        }

        this.setState({
            addingExercise: searchText.length > 0,
            searchText,
            instructions
        });

        window.scrollTo(0, 0);

    };
    OnModelOpen = (event, selfIndex) => {
        event.stopPropagation();
        const currentExerciseIndex = selfIndex;
        const newExercises = this.state.exercises.slice(0);
        const currentExercise = newExercises[currentExerciseIndex];
        const currentComment = currentExercise.comment;
        this.setState({
            currentIndex: selfIndex,
            modalIsOpen: true,
            comment: currentComment,
        });
    };
    onModelClose = () => {
        this.setState({modalIsOpen: false});
    };
    onCommentChange = event => {
        this.setState({comment: event.target.value});
    };
    onSaveComment = index => {
        const currentExerciseIndex = index;
        const newExercises = this.state.exercises.slice(0);
        const currentExercise = newExercises[currentExerciseIndex];
        currentExercise.comment = this.state.comment;
        this.setState({exercises: newExercises, demoArray: newExercises}, () => {
            db.updateComment(
                this.state.userId,
                this.state.currentProgram,
                currentExercise,
                this.state.mainLanguage
            );
        });
        this.setState({
            modalIsOpen: false
        });
    };
    onChangeProgramName = event => {
        this.setState({programName: event.target.value});
    };

    onChangeMessage = event => {
        this.setState({message: event.target.value});
    };

    onShowInstruction = event => {
        event.stopPropagation();
        const instructionId = event.target.parentElement.id;
        const showingInstruction = this.state.instructions.find(
            instruction => instruction.id === instructionId
        );
        this.setState({
            showingInstructionStep: 0,
            showingInstruction
        });
    };
    onEditExercise = (event) => {
        event.stopPropagation();
        this.setState({
            createExercise: true,
            addingExercise: false,
            edit: true
        });
        const instructionId = event.target.parentElement.id;
        console.log('event.target.parentElement',event.target.parentElement)
        const showingInstruction = this.state.instructions.find(
            instruction => instruction.id === instructionId
        );
        console.log('showingInstruction===',showingInstruction);
        this.setState({
            editObject: showingInstruction
        });
        this.setState({
            exerciseName: showingInstruction.name,
            abbreviation: showingInstruction.description,
            sets: showingInstruction.sets,
            reps: showingInstruction.repeat,
            purpose: showingInstruction.about,
            repeatUnits: showingInstruction.repeatUnit,
            level: showingInstruction.level,
            mainArray: showingInstruction.steps,
            videoId: showingInstruction.videoId
        })
    };

    resetComponent() {
        this.setState({
            addingExercise: true,
            createExercise: false,
            edit: false,
            exerciseName: "",
            sets: "",
            reps: "",
            purpose: "",
            repeatUnits: "",
            abbreviation: "",
            selectedImage: null,
            level: '',
            mainArray: [{
                firstName: '',
                lastName: '',
                directives: [],
                alternatives: [],
                image: '',
                title: '',
                goal: '',
                alterText: '',
                progress: 0,
            }],
        })
    }

    onupdateExercise() {
        const {editObject} = this.state;
        let Id = editObject.id;
        editObject.name = this.state.exerciseName;
        editObject.description = this.state.abbreviation;
        editObject.level = this.state.level;
        editObject.repeat = this.state.reps;
        editObject.sets = this.state.sets;
        editObject.repeatUnit = this.state.repeatUnits;
        editObject.about = this.state.purpose;
        editObject.steps = this.state.mainArray;
        editObject.videoId = this.state.videoId;
        db.updateEditedExercise(
            Id,
            this.state.exerciseName,
            this.state.abbreviation,
            this.state.level,
            this.state.reps,
            this.state.sets,
            this.state.repeatUnits,
            this.state.purpose,
            this.state.mainArray,
            this.state.userId,
            this.state.videoId,
            this.state.mainLanguage
        )
        setTimeout(() => {
            this.resetComponent()
        }, 2000)
    }

    onCancelShowInstruction = event => {
        this.setState({
            showingInstruction: null
        });
        this.onFocusSearchBox();
    };

    onPreviousStep = event => {
        const showingInstructionStep =
            this.state.showingInstructionStep < 1
                ? 0
                : this.state.showingInstructionStep - 1;
        this.setState({showingInstructionStep});
    };

    onNextStep = event => {
        const showingInstructionStep =
            this.state.showingInstructionStep >=
            this.state.showingInstruction.steps.length - 1
                ? this.state.showingInstruction.steps.length - 1
                : this.state.showingInstructionStep + 1;
        this.setState({showingInstructionStep});
    };

    onAddExercise = event => {
        this.setState({addingExercise: true});
    };

    onCancelAddExercise = event => {
        this.setState({
            addingExercise: false,
            searchText: ""
        });
        this.onFocusSearchBox();
    };

    addExercise = (event) => {
        const currentExerciseNumber = this.state.currentExerciseNumber === null ? this.state.exercises.length : this.state.currentExerciseNumber + 1;
        this.state.instructions.filter(instruction => instruction.id === event.currentTarget.id)
            .map(async (instruction) => {
                const newExercises = this.state.exercises.slice(0);
                newExercises.splice(currentExerciseNumber, 0, {
                    id: this.state.nextExerciseId,
                    instructionId: instruction.id,
                    name: instruction.name,
                    shortText: instruction.shortText,
                    text: instruction.text || "",
                    videoId: instruction.videoId,
                    repeat: instruction.repeat || 4,
                    shortTrackRepeat: instruction.shortTrackRepeat || instruction.repeat,
                    multiTrackRepeat: instruction.multiTrackRepeat || instruction.repeat,
                    repeatUnit: instruction.repeatUnit,
                    sets: instruction.sets || 2,
                    shortTrackSets: instruction.shortTrackSets || instruction.sets,
                    multiTrackSets: instruction.multiTrackSets || instruction.sets,
                    grouped: false,
                    groupedFirst: false,
                    groupedShortTracK: false,
                    groupedShortTracKFirst: false,
                    groupedMultiTrack: false,
                    groupedMultiTrackFirst: false,
                    shortTrack: this.state.currentVersionIndex === 1 ? true : false,
                    multiTrack: this.state.currentVersionIndex === 0 ? true : false,
                    steps: instruction.steps,
                    about: instruction.about,
                    affects: instruction.affects,
                    comment: this.state.comment
                });
                await this.markFirstInGroup(newExercises);
                this.setState(
                    {
                        demoArray: newExercises,
                        exercises: newExercises,
                        currentExerciseNumber: currentExerciseNumber,
                        nextExerciseId: this.state.nextExerciseId + 1,
                        addingExercise: false,
                        searchText: "",
                    },
                    () => {
                        db.addExercise(
                            this.state.userId,
                            this.state.currentProgram,
                            newExercises[currentExerciseNumber],
                            currentExerciseNumber
                        );

                        for (
                            let i = currentExerciseNumber + 1;
                            i < this.state.exercises.length;
                            i++
                        ) {
                            db.moveExercise(
                                this.state.userId,
                                this.state.currentProgram,
                                newExercises[i].id,
                                i
                            );
                        }
                    }
                );
                this.onFocusSearchBox();
                this.FilterBasedOnVersion(this.state.currentVersionIndex)
            });
    };

    onChangeSets = (key, event, item) => {
        event.stopPropagation();
        // const currentExerciseIndex = Number(
        //     event.currentTarget.parentElement.parentElement.parentElement.id
        // );
        const currentExerciseIndex = Number(
            this.state.exercises.findIndex((data) => {
                return data.id == item.id
            })
        );
        const newExercises = this.state.exercises.slice(0);
        const currentExercise = newExercises[currentExerciseIndex];
        currentExercise[key] = event.target.value;
        this.setState({exercises: newExercises, demoArray: newExercises}, () => {
            db.updateExercise(
                this.state.userId,
                this.state.currentProgram,
                currentExercise
            );
        });
    };

    onChangeRepeat = (key, event, item) => {
        event.stopPropagation();
        const currentExerciseIndex = Number(
            this.state.exercises.findIndex((data) => {
                return data.id == item.id
            })
        );
        // const currentExerciseIndex = Number(
        //     event.currentTarget.parentElement.parentElement.parentElement.id
        // );
        const newExercises = this.state.exercises.slice(0);
        const currentExercise = newExercises[currentExerciseIndex];
        currentExercise[key] = event.target.value;
        this.setState({exercises: newExercises, demoArray: newExercises}, () => {
            db.updateExercise(
                this.state.userId,
                this.state.currentProgram,
                currentExercise
            );
        });
    };


    // onChangeGrouped = (key, parentKey, event, item) => {
    //     event.stopPropagation();
    //     //     const newExercises = this.state[this.state.currentVersionIndex === 1 ? 'shortTrackArray' : this.state.currentVersionIndex === 0 ? 'multiTrackArray' : 'exercises'];
    //     const newExercises = this.state.exercises.slice(0);
    //     // const currentExerciseNumber = Number(event.currentTarget.parentElement.id);
    //     const currentExerciseNumber = this.state.exercises.findIndex((data) => {
    //             return data.id == item.id
    //         })
    //     ;
    //
    //     console.log('currentExerciseNumber', currentExerciseNumber)
    //     const currentExercise = newExercises[currentExerciseNumber];
    //     const previousExercise = newExercises[currentExerciseNumber - 1];
    //
    //     if (currentExercise[parentKey]) {
    //         currentExercise[key] = false;
    //         currentExercise[parentKey] = false;
    //     } else if (currentExercise[key]) {
    //         if (previousExercise && previousExercise[parentKey]) {
    //             currentExercise[key] = false;
    //         } else {
    //             currentExercise[parentKey] = true;
    //         }
    //     } else {
    //         currentExercise[key] = true;
    //     }
    //
    //     this.markFirstInGroup(newExercises, key, parentKey);
    //     this.setState({exercises: newExercises}, () => {
    //         db.updateExercise(
    //             this.state.userId,
    //             this.state.currentProgram,
    //             currentExercise
    //         );
    //     });
    // };

    onChangeGrouped = (key, parentKey, event, item) => {
        event.stopPropagation();
        // const newExercises = this.state.exercises.slice(0);
        // // const currentExerciseNumber = Number(event.currentTarget.parentElement.id);
        // const currentExerciseNumber = Number(
        //     this.state.exercises.findIndex((data)=>{
        //         return data.id==item.id
        //     })
        // );
        const LatestExerciseArray =
            this.state[this.state.currentVersionIndex === 1 ? 'shortTrackArray' :
                this.state.currentVersionIndex === 0 ? 'multiTrackArray' : 'exercises']
        ;

        const LatestExerciseNumber = Number(
            LatestExerciseArray.findIndex((data) => {
                return data.id == item.id
            })
        );


        const currentExercise = LatestExerciseArray[LatestExerciseNumber];
        const previousExercise = LatestExerciseArray[LatestExerciseNumber - 1];

        if (currentExercise[parentKey]) {
            currentExercise[key] = false;
            currentExercise[parentKey] = false;
        } else if (currentExercise[key]) {
            if (previousExercise && previousExercise[parentKey]) {
                currentExercise[key] = false;
            } else {
                currentExercise[parentKey] = true;
            }
        } else {
            currentExercise[key] = true;
        }

        this.markFirstInGroup(LatestExerciseArray, key, parentKey);
        this.setState({exercises: LatestExerciseArray}, () => {
            db.updateExercise(
                this.state.userId,
                this.state.currentProgram,
                currentExercise
            );
        });
    };

    markFirstInGroup = (exercises, key, parentKey) => {
        let previousGrouped = false;
        let previousGroupedFirst = false;
        const newExercises = exercises.map(exercise => {
            const groupedFirstBefore = exercise[parentKey];
            exercise[parentKey] = !previousGroupedFirst && ((exercise[key] && exercise[parentKey]) ||
                (exercise[key] && !previousGrouped));
            if (groupedFirstBefore != exercise[parentKey]) {
                db.updateExercise(
                    this.state.userId,
                    this.state.currentProgram,
                    exercise
                );
            }
            previousGrouped = exercise[key];
            previousGroupedFirst = exercise[parentKey];
        });
        return newExercises;
    };

    onChangeShortTrack = (event, item) => {
        event.stopPropagation();
        // const currentExerciseIndex = Number(
        //     event.currentTarget.parentElement.parentElement.id
        // );

        const currentExerciseIndex = Number(
            this.state.exercises.findIndex((data) => {
                return data.id == item.id
            })
        );

        const newExercises = this.state.exercises.slice(0);
        const currentExercise = newExercises[currentExerciseIndex];
        currentExercise.shortTrack = !currentExercise.shortTrack;
        this.setState(
            {
                exercises: newExercises, demoArray: newExercises,
                currentExerciseNumber: undefined
            }, () => {
                db.updateExercise(
                    this.state.userId,
                    this.state.currentProgram,
                    currentExercise
                );
                this.FilterBasedOnVersion(this.state.currentVersionIndex)
            });

    };
    onChangeMultiTrack = (event, item) => {
        event.stopPropagation();
        // const currentExerciseIndex = Number(
        //     event.currentTarget.parentElement.parentElement.id
        // );
        const currentExerciseIndex = Number(
            this.state.exercises.findIndex((data) => {
                return data.id == item.id
            })
        );
        const newExercises = this.state.exercises.slice(0);
        const currentExercise = newExercises[currentExerciseIndex];
        currentExercise.multiTrack = !currentExercise.multiTrack;
        this.setState({exercises: newExercises, demoArray: newExercises, currentExerciseNumber: undefined}, () => {
            db.updateExercise(
                this.state.userId,
                this.state.currentProgram,
                currentExercise,
            );
            console.log('current Exercise==', currentExercise)
            this.FilterBasedOnVersion(this.state.currentVersionIndex)
        });

    };

    onMoveUp = event => {
        event.stopPropagation();
        const newExercises = this.state.exercises.slice(0);
        const currentExerciseIndex = Number(
            event.currentTarget.parentElement.parentElement.id
        );
        const currentExerciseId = newExercises[currentExerciseIndex].id;
        const previousExerciseIndex = currentExerciseIndex < 1 ? 0 : currentExerciseIndex - 1;
        const previousExerciseId = newExercises[previousExerciseIndex].id;
        const previousExercise = newExercises[previousExerciseIndex];
        newExercises[previousExerciseIndex] = newExercises[currentExerciseIndex];
        newExercises[currentExerciseIndex] = previousExercise;
        this.markFirstInGroup(newExercises);
        this.setState(
            {
                demoArray: newExercises,
                exercises: newExercises,
                currentExerciseNumber: previousExerciseIndex
            },
            () => {
                db.moveExercise(
                    this.state.userId,
                    this.state.currentProgram,
                    previousExerciseId,
                    currentExerciseIndex
                );
                db.moveExercise(
                    this.state.userId,
                    this.state.currentProgram,
                    currentExerciseId,
                    previousExerciseIndex
                );
            }
        );
    };

    onMoveDown = event => {
        event.stopPropagation();
        const newExercises = this.state.exercises.slice(0);
        const currentExerciseIndex = Number(
            event.currentTarget.parentElement.parentElement.id
        );
        const currentExerciseId = newExercises[currentExerciseIndex].id;
        const nextExerciseIndex =
            currentExerciseIndex === newExercises.length - 1
                ? currentExerciseIndex
                : currentExerciseIndex + 1;
        const nextExerciseId = newExercises[nextExerciseIndex].id;
        const nextExercise = newExercises[nextExerciseIndex];
        newExercises[nextExerciseIndex] = newExercises[currentExerciseIndex];
        newExercises[currentExerciseIndex] = nextExercise;
        this.markFirstInGroup(newExercises);
        this.setState(
            {
                demoArray: newExercises,
                exercises: newExercises,
                currentExerciseNumber: nextExerciseIndex
            },
            () => {
                db.moveExercise(
                    this.state.userId,
                    this.state.currentProgram,
                    nextExerciseId,
                    currentExerciseIndex
                );
                db.moveExercise(
                    this.state.userId,
                    this.state.currentProgram,
                    currentExerciseId,
                    nextExerciseIndex
                );
            }
        );
    };

    onRemoveExercise = (event) => {
        const addingExercise = this.state.exercises.length === 1 ? true : false;
        const currentExerciseNumber = addingExercise ? 0 : this.state.currentExerciseNumber > 1 ? this.state.currentExerciseNumber - 1 : 1;
        const exercise = this.state.exercises[this.state.currentExerciseNumber];
        console.log('exercise', exercise);
        const exercises = this.state.exercises.filter(
            (_, index) =>
                index !== Number(event.currentTarget.parentElement.parentElement.id)
        );
        this.markFirstInGroup(exercises);
        this.setState(
            {
                exercises,
                currentExerciseNumber,
                addingExercise,
                demoArray: exercises,
            },
            () => {
                db.removeExercise(
                    this.state.userId,
                    this.state.currentProgram,
                    exercise
                );

                for (
                    let i = currentExerciseNumber + 1;
                    i < this.state.exercises.length;
                    i++
                ) {
                    db.moveExercise(
                        this.state.userId,
                        this.state.currentProgram,
                        exercises[i].id,
                        i
                    );
                }
            }
        );
        this.onFocusSearchBox();
        // this.FilterBasedOnVersion(this.state.currentVersionIndex)
    };

    getClientEmail(){
        let email=window.localStorage.getItem("clientEmail");
        this.setState({
            modifiedBy:email
        },()=>{
            console.log("modifiedBy=====",this.state.modifiedBy)
        });
    }


    componentWillMount() {
        const self = this;
        const queryString = this.getQueryStringParameters(
            this.props.location.search
        );
        const userId = queryString.user;
        const programId = Number(queryString.program || 0);
        const templateId = Number(queryString.template || 0);

        self.setState({
            authenticating: true
        });
        firebase.auth.onAuthStateChanged(user => {
            if (!user) {
                return this.redirectToRoot("Not authenticated!");
            }

            self.setState({
                authUser: user,
                authenticating: false
            });

            db.getUser(userId || user.email)
                .then(user => {
                    self.setState({
                        user,
                        userId: user.id
                    });
                    this.getClientEmail()
                    this.props.history.push({
                        search: `?user=${encodeURIComponent(user.id)}&program=${programId}`
                    });
                    return user;
                })
                .then(user => {
                    if (templateId) {
                        return db
                            .createProgram(user.id, user.name, user.currentProgram)
                            .then(program => {
                                return db
                                    .getProgram(this.state.authUser.email, templateId)
                                    .then(template => {
                                        program.name = template.name;
                                        program.message = template.message;
                                        return program;
                                    });
                            });
                    } else if (programId) {
                        return db.getProgram(user.id, programId);
                    } else {
                        return db.createProgram(user.id, user.name, user.currentProgram);
                    }
                })
                .then(program => {
                    console.log("template", program);
                    self.setState({
                        programName: program.name,
                        message: program.message || this.state.message,
                        currentProgram: program.id
                    });
                    console.log("Current program: ", program.id);

                    if (templateId) {
                        return db
                            .getExercises(this.state.authUser.email, templateId)
                            .then(exercises => {
                                exercises.map((exercise, index) => {
                                    db.addExercise(
                                        this.state.user.id,
                                        program.id,
                                        exercise,
                                        index + 1
                                    );
                                });
                                return exercises;
                            });
                    } else {
                        return db.getExercises(this.state.user.id, program.id);
                    }
                })
                .then(exercises => {
                    self.setState(
                        {
                            exercises,
                            nextExerciseId:
                                Math.max(...exercises.map(exercise => exercise.id), 0) + 1
                        },
                        () => {
                            console.log("Exercises loaded: ", exercises.length);
                        }
                    );
                })
                .catch(errorMessage => {
                    this.redirectToRoot(errorMessage);
                });

            db.getPractitioner()
                .then(practitioner => {
                    self.setState({
                        practitionerData:practitioner
                    })
                    return db.getInstructions(practitioner.level);
                })
                .then(allInstructions => {
                    self.setState({allInstructions}, () => {
                        if (self.state.searchText.length > 0) {
                            self.onChangeSearchText({
                                target: {value: self.state.searchText}
                            });
                        }
                        console.log("Instructions loaded: ", allInstructions.length);
                    });
                })
                .catch(errorMessage => {
                    this.redirectToRoot(errorMessage);
                });

            db.getTips(this.state.masterUserId)
                .then(tipsData => {
                    self.setState({
                        Tips:tipsData.tips
                    })
                }).catch(errorMessage => {
                this.redirectToRoot(errorMessage);
            });
        });
    }

    redirectToRoot(errorMessage) {
        console.log(errorMessage);
    }

    getQueryStringParameters = query => {
        return query
            ? (/^[?#]/.test(query) ? query.slice(1) : query)
                .split("&")
                .reduce((params, param) => {
                    let [key, value] = param.split("=");
                    params[key] = value
                        ? decodeURIComponent(value.replace(/\+/g, " "))
                        : "";
                    return params;
                }, {})
            : {};
    };

    async FilterBasedOnVersion(index) {
        this.setState({
            currentVersionIndex: index,
            exercises: this.state.demoArray
        }, () => {
            const newExercises = this.state.demoArray.slice(0);
            const {currentVersionIndex} = this.state;
            if (currentVersionIndex === 0) {
                const multiTrackResult = newExercises.filter(exercise => exercise.multiTrack === true);
                this.setState({
                    multiTrackArray: multiTrackResult
                })
            }
            if (currentVersionIndex === 1) {
                const shortTrackResult = newExercises.filter(exercise => exercise.shortTrack === true);
                this.setState({
                    shortTrackArray: shortTrackResult
                })
            }
        })
    }

    onAnotherEmailChange = (event) => {
        this.setState({
            anotherEmailAddress: event.target.value
        })
    };

    createNew() {
        this.setState({
            createExercise: true,
            addingExercise: false,
        })
    }

    onCancelCreateAddExercise() {
        this.resetComponent()
    }

    preUserEmailChange = (event) => {
        this.setState({
            userId: event.target.value
        })
    };
    onExerciseNameChange = (event) => {
        this.setState({
            exerciseName: event.target.value
        })
    }
    onSetsChange = (event) => {
        this.setState({
            sets: event.target.value
        })
    }
    onRepsChange = (event) => {
        this.setState({
            reps: event.target.value
        })
    }
    onPurposeChange = (event) => {
        this.setState({
            purpose: event.target.value
        })
    }
    onLevelChange = (event) => {
        this.setState({
            level: event.target.value
        })
    }
    repeatUnits = (event) => {
        this.setState({
            repeatUnits: event.target.value
        })
    }
    onAbbreviationChange = (event) => {
        this.setState({
            abbreviation: event.target.value
        })
    }
    onVideoIdChange = (event) => {
        this.setState({
            videoId: event.target.value
        })
    }
    onSignOut = () => {
        auth.doSignOut();
        this.setState({
            authenticating: false,
            authUser: null,
            allUsers: [],
            users: [],
            userId: '',
            user: null,
            searchText: '',
            renderLogin: true,
            showingDetails: false,
            addingMessage: false,
            addingExercise: false,
            createExercise: false,
            addTipsPage: false,
        });
        this.props.history.push({
            pathname: '/'
        })
    };

    onSortExercises(flowName) {
        this.setState({
            buttonChange: !this.state.buttonChange
        }, () => {
            if (flowName === 'Optimumflöde') {
                const {instructions} = this.state;
                const shortByOptimumFlow = _.sortBy(instructions, 'flowNumber');
                this.setState({
                    instructions: shortByOptimumFlow
                })
            }
            if (flowName === 'Bokstavsflöde') {
                const {instructions} = this.state;
                const shortByOriginalFlow = _.sortBy(instructions, 'name');
                this.setState({
                    instructions: shortByOriginalFlow
                })
            }
        })
    }

    onPublishNewExercise() {
        this.setState({
            showBase64: true
        })
        if (this.state.userId === 'info@optimum-metoden.se') {
            db.onCreateNewExerciseGlobally(
                this.state.abbreviation,
                this.state.exerciseName,
                this.state.sets,
                this.state.reps,
                this.state.repeatUnits,
                this.state.purpose,
                this.state.level,
                this.state.mainArray,
                this.state.userId,
                this.state.videoId,
                this.state.mainLanguage
            )
        } else {
            db.onCreateNewExerciseGlobally(
                this.state.abbreviation,
                this.state.exerciseName,
                this.state.sets,
                this.state.reps,
                this.state.repeatUnits,
                this.state.purpose,
                this.state.demoLevel,
                this.state.mainArray,
                this.state.userId,
                this.state.videoId,
                this.state.mainLanguage
            )
        }

        setTimeout(() => {
            this.resetComponent()
        }, 2000)
    }

    addMultipleFields(event) {
        event.preventDefault();
        let {mainArray} = this.state;
        let newObj = {
            firstName: '',
            lastName: '',
            directives: [],
            alternatives: [],
            image: null,
            title: '',
            goal: '',
            alterText: '',
            progress: 0,
            base64: ''
        }
        this.setState({
            mainArray: [...mainArray, newObj]
        })
    }

    onDeleteFields = (index) => {
        let mainArray = [...this.state.mainArray];
        mainArray.splice(index, 1);
        this.setState({mainArray});
    }

    onDeleteListItems(list_index, mainIndex, key) {
        let mainArray = [...this.state.mainArray];
        let trashArray = mainArray.map((data, j) => {
            if (mainIndex === j) {
                data[key].splice(list_index, 1)
            }
            return data
        })
        this.setState({
            mainArray: trashArray
        })
    }

    handleImageChange(event, index) {
        let a = this.state.mainArray;
        let b = a.map((i, j) => {
            if (index === j) {
                i.image = event.target.files[0];
                let reader = new FileReader();
                reader.readAsDataURL(i.image);
                reader.onloadend = () => {
                    i.base64 = reader.result
                }
            }
            return i
        })
        this.setState({
            mainArray: b,
        }, () => {
            console.log('image', this.state.mainArray)
        })

    }

    handleUploadImage(index) {
        this.setState({seeProgress: true})
        let a = this.state.mainArray;
        let arrayObject = a[index];
        let image = arrayObject.image;
        const uploadTask = storage.ref(`exerciseImages/${image.name}`).put(image);
        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                arrayObject['progress'] = progress
            }, (error) => {
                console.log(error)
            }, () => {
                storage.ref('exerciseImages').child(image.name).getDownloadURL().then(url => {
                    url = arrayObject['base64']
                    arrayObject['image'] = url;
                    a[index] = arrayObject;
                    arrayObject['base64'] = ''
                    this.setState({mainArray: a})
                })
            });
    }


    onChangeListItem(index, event) {
        let mainArray = this.state.mainArray;
        if (event.target.name === 'firstName') {
            mainArray[index].firstName = event.target.value;
        } else {
            mainArray[index].lastName = event.target.value;
        }
        this.setState({
            mainArray
        })

    }

    onGoalChange(index, event) {
        let mainArray = this.state.mainArray;
        mainArray[index].goal = event.target.value;
        this.setState({
            mainArray
        })
    }

    onAlterChange(index, event) {
        let mainArray = this.state.mainArray;
        mainArray[index].alterText = event.target.value;
        this.setState({
            mainArray
        })
    }

    onAddItem(value, index) {
        const {mainArray} = this.state;
        let tempArray = mainArray.map((data, i) => {
            if (index === i) {
                // data.title=title
                data.directives.push(value);
                data.lastName = ''
            }
            return data;
        })
        this.setState({
            mainArray: tempArray,
        })
    }

    onAddTitle(title, index) {
        const {mainArray} = this.state;
        let tempArray = mainArray.map((data, i) => {
            if (index === i) {
                data.title = title
                // data.firstName=''
            }
            return data;
        })
        this.setState({
            mainArray: tempArray,
        }, () => {
            console.log('mainArray====', mainArray)
        })
    }

    onAddAlterNatives(value, goal, index) {
        const {mainArray} = this.state;
        let tempArray = mainArray.map((data, i) => {
            if (index === i) {
                data.goal = goal
                data.alternatives.push(value)
                data.alterText = ''
            }
            return data;
        })
        this.setState({
            mainArray: tempArray
        })
    }

    onTipsPage() {
        this.setState({
            addTipsPage: true,
            createExercise: false
        })
    }

    onTitleChange(event) {
        this.setState({
            titleText: event.target.value
        })
    }

    onBodyChange(event) {
        this.setState({
            bodyText: event.target.value
        })
    }

    onCancelTipsPage() {
        this.setState({
            addTipsPage: false,
            createExercise: true
        })
    }

    onAddTip() {
        let mainTipsArray = [...this.state.Tips]
        mainTipsArray.push({
            tipTitle: this.state.titleText,
            tipDetails: this.state.bodyText,
            userId: this.state.userId,
        })
        this.setState({
            Tips: mainTipsArray,
            titleText: '',
            bodyText: ''
        })
    }

    onRemoveTips(tip_index) {
        let mainTipsArray = [...this.state.Tips]
        mainTipsArray.splice(tip_index, 1);
        this.setState({
            Tips: mainTipsArray,
        })
    }

    onSaveTips() {
        db.saveTips(this.state.Tips, this.state.masterUserId, this.state.mainLanguage)
        setTimeout(() => {
            this.setState({
                addTipsPage: false,
                createExercise: true
            })
        }, 2000)

    }


    renderAddMessage() {
        const {mainLanguage} = this.state;
        return (
            <AppContainer>

                    <>
                        <Header>
                            <Heading>
                                <Flex>
                                    <div>
                                        <IconButton
                                            icon={previous}
                                            height={"1.1rem"}
                                            onClick={this.onCancelAddMessage}
                                        />
                                    </div>
                                    <EllipsisText>
                                        &nbsp; {this.state.user ? this.state.user.name : "..."}
                                    </EllipsisText>
                                </Flex>
                            </Heading>
                            <LogoutItemAction>
                                <LogoutButton onClick={this.onSignOut}>
                                    {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                                </LogoutButton>
                            </LogoutItemAction>
                            <InputContainer>
                                <InputText
                                    value={this.state.programName}
                                    onChange={this.onChangeProgramName}
                                    placeholder={"Namn på programmet"}
                                    autoFocus
                                />
                            </InputContainer>
                        </Header>

                        <Body>
                            <Info>
                                <InputTextArea
                                    value={this.state.message}
                                    onChange={this.onChangeMessage}
                                    placeholder={"Skriv ett meddelande till kunden."}
                                    autoFocus
                                />
                            </Info>

                            <EmailInfo>
                                <AboveEmailText>
                                    {mainLanguage === 'English' ? en.programSent : mainLanguage === 'Spanish' ? spn.programSent : swe.programSent}
                                </AboveEmailText>
                                <InputEmail
                                    value={(this.state.userId)}
                                />
                                <EmailText>
                                    {mainLanguage === 'English' ? en.additionalPerson : mainLanguage === 'Spanish' ? spn.additionalPerson : swe.additionalPerson}

                                </EmailText>
                                <InputEmail
                                    value={this.state.anotherEmailAddress}
                                    onChange={this.onAnotherEmailChange}
                                />
                            </EmailInfo>
                        </Body>

                        <MainAction>
                            {/* <GreenLargeButton onClick={this.onPublishProgram}>Spara som mall</GreenLargeButton> */}
                            &nbsp;
                            <GreenLargeButton onClick={this.onPublishProgram}>
                                {mainLanguage === 'English' ? en.Skicka : mainLanguage === 'Spanish' ? spn.Skicka : swe.Skicka}
                            </GreenLargeButton>
                            <NotificationContainer/>
                        </MainAction>
                    </>

            </AppContainer>
        );
    }

    renderAddExercise() {
        const {mainLanguage,allow} = this.state;
        return (
            <AppContainer>

                    <>

                        <Header>
                            <Heading>
                                <Flex>
                                    <div>
                                        <IconButton
                                            icon={previous}
                                            height={"1.1rem"}
                                            onClick={this.onCancelAddExercise}
                                        />
                                    </div>
                                    <EllipsisText>
                                        &nbsp; {this.state.user ? this.state.user.name : "..."}
                                    </EllipsisText>
                                </Flex>
                            </Heading>
                            <LogoutItemAction>
                                {this.state.practitionerData.level >= 500 &&
                                <LogoutButton onClick={() => {
                                    this.createNew()
                                }}>
                                    {mainLanguage === 'English' ? en.Skapaövning : mainLanguage === 'Spanish' ? spn.Skapaövning : swe.Skapaövning}

                                </LogoutButton>}
                                {this.state.buttonChange ?
                                    <SortingButton onClick={() => {
                                        this.onSortExercises('Bokstavsflöde')
                                    }}>
                                        {mainLanguage === 'English' ? en.Bokstavsflöde : mainLanguage === 'Spanish' ? spn.Bokstavsflöde : swe.Bokstavsflöde}

                                    </SortingButton>
                                    :
                                    <SortingButton onClick={() => {
                                        this.onSortExercises('Optimumflöde')
                                    }}>
                                        {mainLanguage === 'English' ? en.Optimumflöde : mainLanguage === 'Spanish' ? spn.Optimumflöde : swe.Optimumflöde}

                                    </SortingButton>
                                }

                                <LogoutButton onClick={this.onSignOut}>
                                    {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                                </LogoutButton>
                            </LogoutItemAction>
                            <SearchBox
                                setSearchBoxRef={this.setSearchBoxRef}
                                value={this.state.searchText}
                                onChange={this.onChangeSearchText}
                                onArrowKeys={this.onKeypress}
                                placeholder={"RS, Quad, Hooklying..."}
                            />
                        </Header>

                        <Body>
                            <SearchHits hits={this.state.instructions}>
                                <SearchHit
                                    onClick={this.addExercise}
                                    onDetailsClick={this.onShowInstruction}
                                    onEditExercise={this.onEditExercise}
                                    mainId={this.state.userId}
                                    clientEmail={this.state.modifiedBy}
                                    masterUserId={this.state.masterUserId}
                                    instructionHit={this.state.instructionHit}
                                    showBase64={this.state.showBase64}
                                    mainLanguage={this.state.mainLanguage}
                                />
                            </SearchHits>
                        </Body>
                    </>
            </AppContainer>
        );
    }

    renderCreateOwnExercise() {
        const {mainLanguage} = this.state;
        return (
            <CreateAppContainer>
                <Header>
                    <Heading>
                        <Flex>
                            <div>
                                <IconButton
                                    icon={previous}
                                    height={"1.1rem"}
                                    onClick={() => {
                                        this.onCancelCreateAddExercise()
                                    }}
                                />
                            </div>
                            <EllipsisText>
                                &nbsp; {this.state.user ? this.state.user.name : "..."}
                            </EllipsisText>
                        </Flex>
                    </Heading>
                    <LogoutItemAction>
                        <SortingButton onClick={() => {
                            this.onTipsPage()
                        }}>
                            {mainLanguage === 'English' ? en.AddTips : mainLanguage === 'Spanish' ? spn.AddTips : swe.AddTips}
                        </SortingButton>
                        <LogoutButton onClick={this.onSignOut}>
                            {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                        </LogoutButton>
                    </LogoutItemAction>
                </Header>
                <Body>
                    {!this.state.edit &&
                    <Note>
                        {mainLanguage === 'English' ? en.Note : mainLanguage === 'Spanish' ? spn.Note : swe.Note}
                    </Note>}
                    <CommonPadding>
                        <CreateExerciseText>
                            {mainLanguage === 'English' ? en.eName : mainLanguage === 'Spanish' ? spn.eName : swe.eName}
                        </CreateExerciseText>
                        <CreateExerciseInputText
                            value={this.state.exerciseName}
                            onChange={this.onExerciseNameChange}
                        />
                        <Purpose>
                            <CreateExerciseText>
                                {mainLanguage === 'English' ? en.abbrevication : mainLanguage === 'Spanish' ? spn.abbrevication : swe.abbrevication}
                            </CreateExerciseText>
                            <CreateExerciseInputText
                                value={this.state.abbreviation}
                                onChange={this.onAbbreviationChange}
                            />
                        </Purpose>
                        <SetsAndReps>
                            <Container>
                                <CreateExerciseText>
                                    {mainLanguage === 'English' ? en.set : mainLanguage === 'Spanish' ? spn.set : swe.set}
                                </CreateExerciseText>
                                <SetsRepsInput
                                    value={this.state.sets}
                                    onChange={this.onSetsChange}
                                />
                            </Container>
                            <CrossContainer>
                                X
                            </CrossContainer>
                            <Container>
                                <CreateExerciseText>
                                    {mainLanguage === 'English' ? en.reps : mainLanguage === 'Spanish' ? spn.reps : swe.reps}
                                </CreateExerciseText>
                                <SetsRepsInput
                                    value={this.state.reps}
                                    onChange={this.onRepsChange}/>
                            </Container>
                            <Container>
                                <CreateExerciseText>
                                    {mainLanguage === 'English' ? en.unit : mainLanguage === 'Spanish' ? spn.unit : swe.unit}
                                </CreateExerciseText>
                                <RepUnitsInput
                                    value={this.state.repeatUnits}
                                    onChange={this.repeatUnits}/>
                            </Container>
                        </SetsAndReps>
                        <Purpose>
                            <CreateExerciseText>
                                {mainLanguage === 'English' ? en.Syfte : mainLanguage === 'Spanish' ? spn.Syfte : swe.Syfte}
                            </CreateExerciseText>
                            <PurposeTextArea
                                value={this.state.purpose}
                                onChange={this.onPurposeChange}/>
                        </Purpose>
                        <Purpose>
                            <CreateExerciseText>
                                {mainLanguage === 'English' ? en.videlolink : mainLanguage === 'Spanish' ? spn.videlolink : swe.videlolink}
                            </CreateExerciseText>
                            <CreateExerciseInputText
                                value={this.state.videoId}
                                onChange={this.onVideoIdChange}
                            />
                        </Purpose>
                        {this.state.userId === 'info@optimum-metoden.se' &&
                        <Purpose>
                            <CreateExerciseText>
                                {mainLanguage === 'English' ? en.level : mainLanguage === 'Spanish' ? spn.level : swe.level}
                            </CreateExerciseText>
                            <CreateExerciseInputText
                                value={this.state.level}
                                onChange={this.onLevelChange}
                            />
                        </Purpose>}
                        <Purpose>
                            <CreateExerciseText>
                                {mainLanguage === 'English' ? en.uPhotos : mainLanguage === 'Spanish' ? spn.uPhotos : swe.uPhotos}
                                <Note>
                                    {mainLanguage === 'English' ? en.Imagesizewarning : mainLanguage === 'Spanish' ? spn.Imagesizewarning : swe.Imagesizewarning}
                                </Note>
                            </CreateExerciseText>
                        </Purpose>
                        <Purpose>
                            <ImageNote>
                                {mainLanguage === 'English' ? en.linkText : mainLanguage === 'Spanish' ? spn.linkText : swe.linkText}
                                - <span style={{color: "blue", cursor: "pointer"}}
                                        onClick={() => window.open('https://www.remove.bg/')}>https://www.remove.bg </span>
                            </ImageNote>
                        </Purpose>
                        {this.state.mainArray.map((item, index) => {
                            let lastName = item.lastName;
                            let title = item.firstName;
                            let alterText = item.alterText;
                            let goal = item.goal;
                            let image = item.image;
                            return (
                                <>
                                    <ExerciseImage key={`${item}~${index}`}>
                                        {String.fromCharCode(65 + index)}.
                                        <ImageContainer>
                                            <ImageInput onChange={(event) => {
                                                this.handleImageChange(event, index)
                                            }}/>
                                            <div style={{"margin-top": "10px", "text-align": "center"}}>
                                                <progress value={item.progress} max='100'/>
                                            </div>
                                            <ImageDivision>
                                                <ParticularExercise src={image || 'http://via.placeholder.com/200x200'}
                                                                    alt='Uploaded Images'/>
                                            </ImageDivision>
                                            <div style={{"text-align": "center"}}>
                                                {image === '' ?
                                                    <DisabledButton>
                                                        {mainLanguage === 'English' ? en.Upload : mainLanguage === 'Spanish' ? spn.Upload : swe.Upload}
                                                    </DisabledButton> :
                                                    <BlueButton onClick={() => {
                                                        this.handleUploadImage(index)
                                                    }}>
                                                        {mainLanguage === 'English' ? en.Upload : mainLanguage === 'Spanish' ? spn.Upload : swe.Upload}                                                     </BlueButton>}
                                            </div>
                                        </ImageContainer>
                                        <Container>
                                            <InstructionHeader
                                                id={"firstName" + index}
                                                name="firstName"
                                                value={item.firstName}
                                                placeholder={"Title"}
                                                onChange={(event) => this.onChangeListItem(index, event)}/>

                                            <InsertButtonDivMain>
                                                <InsertIconButton
                                                    height={"1.1rem"}
                                                    icon={insert}
                                                    onClick={() => {
                                                        this.onAddTitle(title, index)
                                                    }}/>
                                            </InsertButtonDivMain>
                                            <TitleDivision>
                                                {item.title}
                                            </TitleDivision>

                                            <InstructionBody
                                                id={"lastName" + index}
                                                name="lastName"
                                                value={lastName}
                                                placeholder={'directives'}
                                                onChange={(event) => this.onChangeListItem(index, event)}/>
                                            {item.lastName !== "" &&
                                            <InsertButtonDivMain>
                                                <InsertIconButton
                                                    height={"1.1rem"}
                                                    icon={insert}
                                                    onClick={() => {
                                                        this.onAddItem(lastName, index)
                                                    }}/>
                                            </InsertButtonDivMain>}
                                            <List>
                                                {item.directives && item.directives.map((data, c_index) => {
                                                    return (
                                                        <>
                                                            <ListItem>
                                                                {data}
                                                            </ListItem>
                                                            <RemoveButtonListItem>
                                                                <div style={{
                                                                    "text-align": "right",
                                                                    "margin-top": "-28px", "cursor": "pointer"
                                                                }}>
                                                                    <RemoveListIconButton
                                                                        icon={removeList}
                                                                        onClick={() => {
                                                                            this.onDeleteListItems(c_index, index, 'directives')
                                                                        }}
                                                                    />
                                                                </div>
                                                            </RemoveButtonListItem>
                                                        </>
                                                    )
                                                })}
                                            </List>
                                            <InstructionBody
                                                name='goal'
                                                placeholder={"goal"}
                                                value={item.goal}
                                                onChange={(event) => {
                                                    this.onGoalChange(index, event)
                                                }}/>

                                                <InstructionBody
                                                name='alterText'
                                                placeholder={"alternatives"}
                                                value={item.alterText}
                                                onChange={(event) => {
                                                    this.onAlterChange(index, event)
                                                }}/>
                                            {alterText !== "" &&
                                            <InsertButtonDivMain>
                                                <InsertIconButton
                                                    height={"1.1rem"}
                                                    icon={insert}
                                                    onClick={() => {
                                                        this.onAddAlterNatives(alterText, goal, index)
                                                    }}/>
                                            </InsertButtonDivMain>}

                                            <List>
                                                {item.alternatives && item.alternatives.map((data, c_index) => {
                                                    return (
                                                        <>
                                                            <ListItem>
                                                                {data}
                                                            </ListItem>
                                                            <RemoveButtonListItem>
                                                                <div style={{
                                                                    "text-align": "right",
                                                                    "margin-top": "-28px", "cursor": "pointer"
                                                                }}>
                                                                    <RemoveListIconButton
                                                                        icon={removeList}
                                                                        onClick={() => {
                                                                            this.onDeleteListItems(c_index, index, 'alternatives')
                                                                        }}
                                                                    />
                                                                </div>
                                                            </RemoveButtonListItem>

                                                        </>
                                                    )
                                                })}
                                            </List>
                                        </Container>
                                    </ExerciseImage>
                                    {this.state.mainArray.length > 1 &&
                                    <div style={{textAlign: "center", width: "100%", marginTop: "20px"}}>
                                        <DeleteIconButton
                                            icon={deleteIcon}
                                            height={"1.1rem"}
                                            onClick={() => {
                                                this.onDeleteFields(index)
                                            }}
                                        />
                                    </div>
                                    }
                                    <GoalAndDirectives/>
                                    <NotificationContainer/>

                                </>
                            )
                        })}

                        {this.state.mainArray.length < 3 &&
                        <PlusIconButton
                            icon={plus}
                            height={"1.1rem"}
                            onClick={this.addMultipleFields}
                        />}
                    </CommonPadding>
                    {this.state.edit ?
                        <SaveButtonDivision>
                            <BlueButton onClick={(event) => {
                                this.onupdateExercise(event)
                            }}>
                                {mainLanguage === 'English' ? en.Update : mainLanguage === 'Spanish' ? spn.Update : swe.Update}
                            </BlueButton>
                        </SaveButtonDivision> :
                        <SaveButtonDivision>
                            {(this.state.exerciseName === "" || this.state.sets === ""
                                || this.state.reps === "" || this.state.repeatUnits === "" || this.state.purpose === "") ?
                                <DisabledButton>
                                    {mainLanguage === 'English' ? en.Spara : mainLanguage === 'Spanish' ? spn.Spara : swe.Spara}
                                </DisabledButton> :
                                <BlueButton onClick={() => {
                                    this.onPublishNewExercise()
                                }}>
                                    {mainLanguage === 'English' ? en.Spara : mainLanguage === 'Spanish' ? spn.Spara : swe.Spara}
                                </BlueButton>}
                        </SaveButtonDivision>}

                </Body>
            </CreateAppContainer>
        )
    }

    renderTipsPage() {
        return (
            <CreateAppContainer>
                <Header>
                    <Heading>
                        <Flex>
                            <div>
                                <IconButton
                                    icon={previous}
                                    height={"1.1rem"}
                                    onClick={() => {
                                        this.onCancelTipsPage()
                                    }}
                                />
                            </div>
                            <EllipsisText>
                                &nbsp; {this.state.user ? this.state.user.name : "..."}
                            </EllipsisText>
                        </Flex>
                    </Heading>
                    <LogoutItemAction>
                        <LogoutButton onClick={this.onSignOut}>Logga ut</LogoutButton>
                    </LogoutItemAction>
                </Header>
                <Body>
                    <Tips
                        tips={this.state.Tips}
                        titleText={this.state.titleText}
                        bodyText={this.state.bodyText}
                        onTitleChange={(event) => {
                            this.onTitleChange(event)
                        }}
                        onBodyChange={(event) => {
                            this.onBodyChange(event)
                        }}
                        onAddTip={() => {
                            this.onAddTip()
                        }}
                        onRemoveTips={(index) => {
                            this.onRemoveTips(index)
                        }}
                        onSaveTips={() => {
                            this.onSaveTips()
                        }}
                        userId={this.state.userId}
                        masterUserId={this.state.masterUserId}
                    />
                </Body>
                <NotificationContainer/>
            </CreateAppContainer>
        )
    }

    renderLogin() {
        return (
            <AppContainer>
                <OptimumLogo/>
                <MainAction>
                    <ButtonImage src={googleSignIn} onClick={this.onSignIn}/>
                </MainAction>
            </AppContainer>
        );
    }

    renderShowInstruction() {
        const instruction = this.state.showingInstruction;
        const name = instruction.name;
        const displayName = name[0].toUpperCase() + name.substring(1);
        const step = this.state.showingInstructionStep;
        //const text = instruction.steps.length > 2 ? '• ' + step.text.replace(/\. /g, '\n• ') : step.text;

        return (
            <AppContainer>
                <Header>
                    <Heading>
                        <Flex>
                            <div>
                                <IconButton
                                    icon={previous}
                                    height={"1.1rem"}
                                    onClick={this.onCancelShowInstruction}
                                />
                            </div>
                            &nbsp; {displayName}
                        </Flex>
                    </Heading>
                    {/* <SearchBox setSearchBoxRef={this.setSearchBoxRef} value={this.state.searchText} onChange={this.onChangeSearchText} onArrowKeys={this.onKeypress} placeholder={"RS, Quad, Hooklying..."} /> */}
                </Header>

                <Body>
                    {String.fromCharCode(65 + step)}.&nbsp;
                    {instruction.steps[step].title
                        ? instruction.steps[step].title
                        : instruction.steps[step].text}
                    {instruction.steps[step].directives ? (
                        <ul>
                            {instruction.steps[step].directives.map((directive, index) => (
                                <li key={index}>{directive}</li>
                            ))}
                        </ul>
                    ) : null}
                </Body>

                <MainAction>
                    <GreenLargeButton onClick={this.onPreviousStep}>
                        &lt;
                    </GreenLargeButton>
                    <GreenLargeButton onClick={this.onNextStep}>&gt;</GreenLargeButton>
                </MainAction>
            </AppContainer>
        );
    }

    renderShowList() {
        const {currentVersionIndex, mainLanguage, allow} = this.state;
        return (
            <AppContainer>


                    <>
                        <Header>
                            <Heading>
                                <Flex>
                                    <div>
                                        <Link
                                            to={`/show?user=${encodeURIComponent(this.state.userId)}`}
                                        >
                                            <IconButton icon={previous} height={"1.1rem"}/>
                                        </Link>
                                    </div>
                                    <EllipsisText>
                                        &nbsp; {this.state.user ? this.state.user.name : "..."}
                                    </EllipsisText>
                                </Flex>
                            </Heading>
                            <LogoutItemAction>
                                <LogoutButton onClick={this.onSignOut}>
                                    {mainLanguage === 'English' ? en.Logout : mainLanguage === 'Spanish' ? spn.Logout : swe.Logout}
                                </LogoutButton>
                            </LogoutItemAction>
                            <SearchBox
                                setSearchBoxRef={this.setSearchBoxRef}
                                value={this.state.searchText}
                                onChange={this.onChangeSearchText}
                                onArrowKeys={this.onKeypress}
                                placeholder={"RS, Quad, Hooklying..."}
                            />
                            <ItemAction>

                                {this.state.exerciseVersion.map((item, index) => {
                                    return (
                                        <TrackSwitch selected={currentVersionIndex === index ? true : ''}
                                                     onClick={() => {
                                                         this.FilterBasedOnVersion(index)
                                                     }}>{item.version}</TrackSwitch>
                                    )
                                })}
                            </ItemAction>
                        </Header>
                        <SortableListBody>
                            <SortableList
                                items={currentVersionIndex === 0 ? this.state.multiTrackArray : currentVersionIndex === 1 ? this.state.shortTrackArray : currentVersionIndex === 2 ? this.state.exercises : this.state.exercises}
                                currentExerciseNumber={this.state.currentExerciseNumber}
                                onSelect={this.onSelect}
                                onMediumVersionSelect={this.onMediumVersionSelect}
                                onArrowKeys={this.onKeypress}
                                onChangeShortTrack={this.onChangeShortTrack}
                                onChangeMultiTrack={this.onChangeMultiTrack}
                                onChangeSets={this.onChangeSets}
                                onChangeRepeat={this.onChangeRepeat}
                                onChangeGrouped={this.onChangeGrouped}
                                onMoveUp={this.onMoveUp}
                                onMoveDown={this.onMoveDown}
                                onRemoveExercise={this.onRemoveExercise}
                                onCommentChange={this.onCommentChange}
                                comment={this.state.comment}
                                modalIsOpen={this.state.modalIsOpen}
                                onModelClose={this.onModelClose}
                                OnModelOpen={this.OnModelOpen}
                                currentIndex={this.state.currentIndex}
                                onSaveComment={this.onSaveComment}
                                currentVersionIndex={this.state.currentVersionIndex}
                                shortTrackArray={this.state.shortTrackArray}
                                currentMediumExerciseNumber={this.state.currentMediumExerciseNumber}
                                showBase64={this.state.showBase64}
                                loader={this.state.loader}

                            />
                        </SortableListBody>
                        <NotificationContainer/>
                        <MainAction>
                            &nbsp;
                            <GreenLargeButton onClick={this.onAddMessage}>
                                {mainLanguage === 'English' ? en.skapa : mainLanguage === 'Spanish' ? spn.skapa : swe.skapa}
                            </GreenLargeButton>
                        </MainAction>
                    </>

            </AppContainer>
        );
    }

    render() {
        if (this.state.addingMessage) {
            return this.renderAddMessage();
        }

        if (this.state.showingInstruction) {
            return this.renderShowInstruction();
        }

        if (this.state.addingExercise) {
            return this.renderAddExercise();
        }
        if (this.state.renderLogin) {
            return this.renderLogin()
        }
        if (this.state.createExercise) {
            return this.renderCreateOwnExercise()
        }
        if (this.state.addTipsPage) {
            return this.renderTipsPage()
        }
        return this.renderShowList();
    }
}

export default NewPage;
export {
    RemoveListIconButton,
    ImageInput,
}



// WEBPACK FOOTER //
// ./src/pages/new.js